function KeyManagerController(userViewService, userService, KeyManagerService, DescriptorService, PackageService, toasterService, $uibModal) {
  const ctrl = this;
  const getPackageHeader = DescriptorService.getPackageHeader;

  ctrl.$onInit = async () => {
    userViewService.setView('key-manager');
    ctrl.hasCreate = userService.hasCreateKey();
    ctrl.hasDelete = userService.hasDeleteKey();
    ctrl.initLoading = true;
    ctrl.keys = await fetchKeys();
    ctrl.initLoading = false;
    ctrl.packages = await fetchPackages();
    checkKeyAvailability(ctrl.keys, ctrl.packages);
  };

  const fetchKeys = async () => {
    try {
      return await KeyManagerService.getKeys();
    }
    catch (e) {
      return `Error fetching keys: ${e}`;
    }
  };

  const fetchPackages = async () => {
    try {
      return await PackageService.getAllPackages();
    }
    catch (e) {
      return `Error fetching keys: ${e}`;
    }
  };

  const checkKeyAvailability = (keys, packages) => {
    keys.map(key => {
      if (packages.find(pkg => key.keyId === getPackageHeader(pkg).package_id)) key.packageExists = true;
    });
  };

  ctrl.generateKey = async (type) => {
    if (!ctrl.hasCreate) return;

    const modalInstance = $uibModal.open({
      component: 'keyGenerationModal',
      backdrop: 'static',
      windowClass: 'large-size-modal',
      resolve: {
        key: () => event.key,
      },
    });

    modalInstance.result.then(
      async (selectedKeyType) => {
        // User pressed 'Yes' in the modal.
        ctrl.key_proge = true;
        ctrl.loading = true;
        try {
          await KeyManagerService.generateKey({ keyType: selectedKeyType.type, keyTarget: selectedKeyType.target });
        }
        catch (e) {
          toasterService.error('key-manager.generate-failure');
          return `Error creating a key: ${e}`;
        }
        finally {
          toasterService.success('key-manager.generate-success');
          ctrl.key_proge = false;
          ctrl.keys = await fetchKeys();
          ctrl.loading = false;
          checkKeyAvailability(ctrl.keys, ctrl.packages);
        }
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.onPackageGenerate = event => {
    if (!event.key || !event.key.keyId) return;
    const modalInstance = $uibModal.open({
      component: 'keyManagerModal',
      backdrop: 'static',
      windowClass: 'large-size-modal',
      resolve: {
        key: () => event.key,
      },
    });

    modalInstance.result.then(
      async (value) => {
        // User pressed 'Yes' in the modal.
        if (value !== 'accepted') return;
        try {
          ctrl.generatePackageRes = await KeyManagerService.generatePackage(event.key.keyId);
        }
        catch (e) {
          toasterService.error('key-manager.generate-pac-failure');
          return `Error generating package: ${e}`;
        }
        finally {
          if (ctrl.generatePackageRes.statusCode === 200) toasterService.success('key-manager.generate-pac-success');
          if (ctrl.generatePackageRes.statusCode !== 200) toasterService.error('key-manager.generate-pac-failure-duplicate');
        }
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('key-manager.module')
  .controller('KeyManagerController', KeyManagerController);
